import {
  Autocomplete,
  FormControl,
  FormLabel,
  Stack,
  TextField,
} from '@mui/material';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterSchemaLocation } from '@/packages/courses/types/schema';

export const FilterLocation = ({
  id,
  title,
  statesOptions,
  citiesOptionsByState,
}: FilterSchemaLocation) => {
  const { params, actions } = useCatalogFilters();
  const locationValues = params[id] ?? [];
  const state = locationValues[0] ?? '';
  const city = locationValues[1] ?? '';

  const stateOption = statesOptions.find((o) => o.value === state) ?? null;
  const cityOptions = state ? (citiesOptionsByState[state] ?? []) : [];
  const cityOption = cityOptions.find((o) => o.value === city) ?? null;

  const handleStateChange = (
    _: unknown,
    newValue: { label: string; value: string } | null
  ) => {
    const newState = newValue?.value ?? '';
    actions.setParam(id, newState ? [newState] : undefined);
  };

  const handleCityChange = (
    _: unknown,
    newValue: { label: string; value: string } | null
  ) => {
    const newCity = newValue?.value ?? '';
    actions.setParam(
      id,
      state && newCity ? [state, newCity] : state ? [state] : undefined
    );
  };

  return (
    <FormControl fullWidth component="fieldset">
      <FormLabel component="legend">{title}</FormLabel>
      <Stack gap={1.5}>
        <Autocomplete
          options={statesOptions}
          value={stateOption}
          getOptionLabel={(opt) => opt.label}
          isOptionEqualToValue={(a, b) => a.value === b.value}
          onChange={handleStateChange}
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="Estado" />
          )}
        />
        <Autocomplete
          options={cityOptions}
          value={cityOption}
          getOptionLabel={(opt) => opt.label}
          isOptionEqualToValue={(a, b) => a.value === b.value}
          onChange={handleCityChange}
          disabled={!state}
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="Cidade" />
          )}
        />
      </Stack>
    </FormControl>
  );
};
